import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import {AccountPage} from '../account/account'

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomePage {

    constructor(public navCtrl: NavController) {

    }

    goto_account() {
        this.navCtrl.push(AccountPage);
    }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts